export const BO_GROUP_LIST_PAGE_SIZE = 10;

export enum OrdersPageTabs {
  ALL = "all",
  NOT_SHIPPED = "not-shipped",
  SHIPPED = "shipped",
  PURCHASE_ORDERS = "purchase-orders",
  ACTION_REQUIRED = "action-required",
  SAMPLES = "samples",
}

export const BO_GROUPS_LIST_KEY = "bo-groups-list";
